import axios from 'axios'
import store from '../store'
// helpers
import {getWordSplit} from  "@/utils/helpers"
import {pushed, pushedDouble, pushedTriple} from '@/utils/constants'

// api calls
const auth = {
  username: "read_only_user",
  password: "kuchaReadOnly"
}

export function getDictionary(name){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_dic/_doc/' : 'kucha_dic/_doc/'
  return axios({
    url: process.env.VUE_APP_ESAPI + index + name,
    method: 'get',
    auth: auth,
    data: {
    }
  })
}
export function isValidImage(image, sessionID){
  const url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? process.env.VUE_APP_USERREG_TEST : process.env.VUE_APP_USERREG

  return axios({
    url: url + 'resource?imageIDValid=' + image.imageID + '&sessionID=' + sessionID,
    method: 'get',
    data: {
    }
  })
}


export function regUser(firstname, surname, email, affiliation){
  const url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? process.env.VUE_APP_USERREG_TEST : process.env.VUE_APP_USERREG

  return axios({
    url: url + 'resource?registerrequest',
    method: 'post',
    auth: auth,
    data: {
      "firstname": firstname,
      "lastname": surname,
      "email": email,
      "affiliation": affiliation
    }
  })
}
export function getCaveEntries(){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'
  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      size: 2000,
      sort:["site.name.keyword", "caveID"],
      query: {
        exists: {
          field: "caveID"
        }
      },
      _source: ["caveID"],
      script_fields: {
        caveEntryName: {
          script: {
            source: "String siteName = doc['site.name.keyword'].value; String officialNumber = doc['officialNumber.keyword'].value; return siteName + ' ' + officialNumber;",
            lang: "painless"
          }
        }
      }
    }
  });
}

export function validateUser(email, pw){
  const url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? process.env.VUE_APP_USERREG_TEST : process.env.VUE_APP_USERREG

  return axios({
    url: url + 'resource?validateUser',
    method: 'post',
    auth: auth,
    data: {
      "email": email,
      "sessionID": pw
    }
  })
}
export function isLoggedIn(sessionID){
  const url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? process.env.VUE_APP_USERREG_TEST : process.env.VUE_APP_USERREG

  return axios({
    url: url + 'resource?isLoggedIn',
    method: 'post',
    auth: auth,
    data: {
      "sessionID": sessionID
    }
  })
}
export function changeUserData(userdata, oldmail, oldPW){
  const url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? process.env.VUE_APP_USERREG_TEST : process.env.VUE_APP_USERREG

  return axios({
    url: url + 'resource?changeUser',
    method: 'post',
    auth: {
      'username':oldmail,
      'password': oldPW
    },
    data: userdata
  })
}
export function putComments(data, uuid, sendMail, sessionID, text){
  const url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? process.env.VUE_APP_USERREG_TEST : process.env.VUE_APP_USERREG

  return axios({
    url: url + 'resource?putComment&uuid=' + uuid + '&sendMail=' + sendMail + '&sessionID=' + sessionID + '&message=' + text,
    method: 'PUT',
    headers: {
      "Content-Type": "application/json; utf-8"
    },
    auth: auth,
    data: data
  })
}
export function publish(item){
  item._source.isUnpublished = !item._source.isUnpublished
  return putNews(item._source, item._id, true, store.state.user.sessionID, "This news was " + item._source.isUnpublished ? "published" : "unpublished")
}
export function putNews(data, uuid, sendMail, sessionID, text){
  const url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? process.env.VUE_APP_USERREG_TEST : process.env.VUE_APP_USERREG

  return axios({
    url: url + 'resource?putNews&uuid=' + uuid + '&sendMail=' + sendMail + '&sessionID=' + sessionID + '&message=' + text,
    method: 'PUT',
    headers: {
      "Content-Type": "application/json; utf-8"
    },
    auth: auth,
    data: data
  })
}
export function getGames(){
  store.commit("setGameLoaded", 0)
  const url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? process.env.VUE_APP_USERREG_TEST : process.env.VUE_APP_USERREG

  return axios({
    url: url + 'resource?getGames',
    method: 'GET',
    headers: {
      "Content-Type": "application/json; utf-8"
    },
    onDownloadProgress: (progressEvent) => {
      let progressData
      const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.srcElement.getResponseHeader('content-length') || progressEvent.originalTarget.getResponseHeader('x-decompressed-content-length');
      if (totalLength !== null) {
        progressData =  (100 * progressEvent.loaded) / totalLength;
      }
      store.commit("setGameLoaded", progressData)
    },
    onUploadProgress: function (evt) {
    }
  })
}
export function getPRList(){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep_test/_search' : 'kucha_deep/_search'
  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'Post',
    auth: auth,
    data: {
      "size": 4000,
      "_source": {
        "exclude": [
          "cave.wallList",
          "cave.preservationClassification",
          "cave.caveAreaList",
          "cave.caveSketchList",
          "relatedAnnotationList",
          "relatedImages",
          "description",
          "positionNotes",
          "relatedIconographyList",
          "relatedBibliographyList"
        ]
      },
      "query": {
        "exists": {
          "field": "depictionID"
        }
      }
    }
  })
}
export function getBiblioList(){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'
  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'Post',
    auth: auth,
    data: {
      "size": 4000,
      "_source": {
        "exclude": [
          "notes",
          "bibtexKey",
          "authorList.affiliation",
          "authorList.email",
          "authorList.homepage",
          "authorList.kuchaVisitor",
          "modifiedOn",
          "authorList.modifiedOn",
          "authorList.authorID",
          "abstractText",
          "url",
          "uri",
          "comments"
        ]
      },
      "query": {
        "exists": {
          "field": "annotatedBibliographyID"
        }
      }
    }
  })
}

export function getIcoList(){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'
  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'Post',
    auth: auth,
    data: {
      "size": 4000,
      "_source": {
        "exclude": [
          "oe"
        ]
      },
      "query": {
        "exists": {
          "field": "iconographyID"
        }
      }
    }
  })
}

export function getCaveEntryByShortName(shortName){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'Post',
    auth: auth,
    data: {
      "size": 1,
      "query": {
        "bool": {
          "must": [
            {
              "exists": {
                "field": "caveID"
              }
            },
            {
              "match": {
                "shortName": shortName,
              }
            }
          ]
        }
      }
    }
  })
}


export function getCaveList(){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'Post',
    auth: auth,
    data: {
      "size": 4000,
      "_source": {
        "exclude": [
          "wallList",
          "caveAreaList"
        ]
      },
      "query": {
        "exists": {
          "field": "caveID"
        }
      }
    }
  })
}
export function getDiscussionKeywords(){
  return axios({
    url: (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? (process.env.VUE_APP_ESAPI + 'kucha_discussion/_search') : (process.env.VUE_APP_ESAPI + 'kucha_discussion/_search'),
    method: 'post',
    auth: auth,
    data: {
      "size":0,
      "aggs": {
        "keywordList": {
          "terms": { "field": "keywordList.keyword" }
        }
      }
    }
  })
}
export function getCommentsByItems(caveIDs, prIDs, icoIDs, biblioIDs){
  let data = {
    "query": {
      "bool": {
        "must": [
          {
            "exists": {
              "field": "isInfo"
            }
          }
        ],
        "should": [
        ]
      }
    }
  }
  let should = {
    "bool": {
      "should": [
      ]
    }
  }

  if (caveIDs.length > 0){
    should.bool.should.push(
      {
        "terms": {
          "caves.value": caveIDs
        }
      }
    )
  }
  if (prIDs.length > 0){
    should.bool.should.push(
      {
        "terms": {
          "prs.value": prIDs
        }
      }
    )
  }
  if (icoIDs.length > 0){
    should.bool.should.push(
      {
        "terms": {
          "iconography.value": icoIDs
        }
      },
    )
  }
  if (biblioIDs.length > 0){
    should.bool.should.push(
      {
        "terms": {
          "bibliography.value": biblioIDs
        }
      }
    )
  }
  data.query.bool.must.push(should)
  return axios({
    url: (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? (process.env.VUE_APP_ESAPI + 'kucha_discussion/_search') : (process.env.VUE_APP_ESAPI + 'kucha_discussion/_search'),
    method: 'post',
    auth: auth,
    data: data
  })
}
export function getNews(expiresAt, isExpiring, isAdmin){

  let data = {}
  if (isAdmin){
    data = {
      "query": {
        "bool": {
          "should": [
          ],
          "must": [
          ]
        }
      }
    }
  } else {
    data = {
      "query": {
        "bool": {
          "must": [
            {
              "bool": {
                "should": [
                  {
                    "range": {
                      "price": {
                        "gte": expiresAt
                      }
                    }
                  },
                  {
                    "term": {
                      "isExpiring": isExpiring
                    }
                  }
                ]
              }
            },
            {
              "term": {
                "isUnpublished": false
              }
            }
          ]
        }
      }
    }
  }
  data["sort"] = {"date" : {"order" : "desc"}}
  return axios({
    url: process.env.VUE_APP_ESAPI + 'kucha_news/_search',
    method: 'post',
    auth: auth,
    data: data
  })
}
export function getComments(){
  return axios({
    url: (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? (process.env.VUE_APP_ESAPI + 'kucha_discussion/_search') : (process.env.VUE_APP_ESAPI + 'kucha_discussion/_search'),
    method: 'post',
    auth: auth,
    data: {
      "size": 4000,
      "query": {
        "exists": {
          "field": "isInfo"
        }
      }
    }
  })
}
export function getWallTreeByTimestamp(timestamp){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_backup/_search' : 'kucha_backup/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      "sort": [
        {"timestamp" : {"order" : "desc"}}
      ],
      "size": 4000,
      "query": {
        "bool": {
          "must": [
            {
              "range": {
                "timestamp": {
                  "lte": timestamp
                }
              }
            },
            {
              "exists": {
                "field": "content.wallTree"
              }
            }
          ]
        }
      }
    }
  })
}
export function getIconogrpaphyByTimestamp(timestamp){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_backup/_search' : 'kucha_backup/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      "sort": [
        {"timestamp" : {"order" : "desc"}}
      ],
      "size": 4000,
      "query": {
        "bool": {
          "must": [
            {
              "range": {
                "timestamp": {
                  "lte": timestamp
                }
              }
            },
            {
              "exists": {
                "field": "content.iconographyTree"
              }
            }
          ]
        }
      }
    }
  })
}
export function getKuchaMapping() {
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_mapping' : 'kucha_deep/_mapping'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'get',
    auth: auth,
    data: {
    }
  })
}

export function getIntro(){
  var url = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? (process.env.VUE_APP_ESAPI + 'kucha_discussion/_doc/introduction') : (process.env.VUE_APP_ESAPI + 'kucha_discussion/_doc/introduction')
  return axios({
    url: url,
    method: 'get',
    auth: auth
  })
}
export function getIntroDiscussions(id){
  let query = {
    "query":{
      "bool": {
        "must": [
          {
            "match": {
              "isInfo" :{
                "query": true
              }
            }
          },
          {
            "match": {
              "introSection" :{
                "query": id
              }
            }
          },
          {
            "match": {
              "published" :{
                "query": true
              }
            }
          }
        ]
      }
    }
  }
  return axios({
    url: (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? (process.env.VUE_APP_ESAPI + 'kucha_discussion/_search') : (process.env.VUE_APP_ESAPI + 'kucha_discussion/_search'),
    method: 'post',
    auth: auth,
    data: query
  })

}

export function getKuchaDiscussionMapping() {
  return axios({
    url: (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? (process.env.VUE_APP_ESAPI + 'kucha_discussion/_mapping') : (process.env.VUE_APP_ESAPI + 'kucha_discussion/_mapping'),
    method: 'get',
    auth: auth,
    data: {
    }
  })
}

export function getDepictionStats() {
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'
  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      "size":0,
      "aggs": {
        "depiction_count": {
          "filter": {
            "exists": {
              "field": "depictionID"
            }
          }
        },
        "genres": {
          "terms": { "field": "cave.site.siteID" }
        },
        "relatedAnnotationList": {
          "nested": {
            "path": "relatedAnnotationList"
          },
          "aggs": {
            "tags": {
              "nested": {
                "path": "relatedAnnotationList.tags"
              },
              "aggs": {
                "genres": {
                  "terms": { "field": "relatedAnnotationList.tags.root" }
                }
              }
            }
          }
        }
      }
    }
  })
}
export function getBibStats() {
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      "size": 0,
      "aggs": {
        "bibliography": {
          "filter": {
            "exists": {
              "field": "annotatedBibliographyID"
            }
          }
        }
      },
      "post_filter": {
        "bool": {
          "must": [
            {
              "exists": {
                "field": "annotatedBibliographyID"
              }
            }
          ],
          "must_not": [
            {
              "wildcard": {
                "annotationHTML": "*"
              }
            }
          ]
        }
      }
    }
  })
}
export function postQuery(queryInput, destination, setsize = true){
  if (setsize) queryInput['size'] = 4000
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'
  if (!destination){
    destination = process.env.VUE_APP_ESAPI + index
  }
  return axios({
    url: destination,
    method: 'post',
    auth: auth,
    data: queryInput
  })
}
export function getIdealByIcoID(icoID){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      "size": 4000,
      "query": {
        "bool": {
          "must": [
            {
              "multi_match": {
                "query": icoID,
                "fields": "iconographyID"
              }
            },
            {
              "exists": {
                "field": "typicalID"
              }
            }
          ]
        }
      }
    }
  })
}
export function getIdeals(){
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      "size": 4000,
      "query": {
        "bool": {
          "must": [
            {
              "exists": {
                "field": "oe.typicalID"
              }
            },
            {
              "multi_match": {
                "query": true,
                "fields": "oe.isVirtualTour"
              }
            }
          ]
        }
      }
    }
  })
}

export function buildNestedQueries(mapping, path, queryWord, excludedSearchfields, excludedNestedObjects){
  let results = []
  for ( var obj in mapping){

    var objPath = path
    if (objPath === ""){
      objPath = obj
    } else {
      objPath += "." + obj
    }
    if (mapping[obj].properties){
      var nestedQueries = buildNestedQueries(mapping[obj].properties, objPath, queryWord, excludedSearchfields, excludedNestedObjects)
      for (let nestedQuery of nestedQueries){
        if (mapping[obj].type === "nested"){
          var subNested = {
            "nested": {
              "path": objPath,
              "query":{
              }
            }
          }
          subNested.nested.query = nestedQuery
          results.push(subNested)
        } else {
          results.push(nestedQuery)
        }
      }
    }
    if (mapping[obj].type === "nested"){
      const isSubstring = (nestedObject) => objPath.includes(nestedObject)

      // Some nested Objects are to be excluded in General Search as they produce confusing results
      if (!excludedNestedObjects.some(isSubstring)){
        var fields = getAllFields([], mapping[obj].properties, excludedSearchfields, objPath + ".", pushed, pushedDouble, pushedTriple)

        var nested = {
          "nested": {
            "path": objPath,
            "query":{
              "query_string": {
                "lenient": true,
                "query" : queryWord,
                "fields": fields,
                "default_operator": "AND"
              }
            }
          }
        }
        if (fields.length > 0){
          results.push(nested)
        }
      } else {
      }
    }
  }

  return results
}
function getAllFields(fields, mapping, excludedFields, prefix, pushed, pushedDouble, pushedTriple){
  console.log("getallfields", mapping)
  for (const field in mapping){
    if (excludedFields && (excludedFields.filter(str => str.includes(field)).length === 0)){
      if (mapping[field].properties){
        if (mapping[field].type !== "nested"){
          fields = getAllFields(fields, mapping[field].properties, excludedFields, prefix + field + ".", pushed, pushedDouble, pushedTriple)
        }
      }
      if (mapping[field].type === "text") {
        if (pushed.includes(prefix + field)){
          fields.push(prefix + field + '^2')
        } else if (pushedDouble.includes(prefix + field)){
          fields.push(prefix + field + '^8')
        } else if (pushedTriple.includes(prefix + field)){
          fields.push(prefix + field + '^36')
        } else {
          fields.push(prefix + field)
        }
      }
    }
  }
  return fields
}
export function searchRoot(params, source) {
  // we need to create a extra field, so that cave has a name field. Otherwise, cave information is in several plaves and not listed properly in results.
  var searchQuery = {
    "from" : params.batchStart ? params.batchStart : 0,
    "_source": true,
    "script_fields": {
      "cave.fullname": {
        "script": {
          "lang": "painless",
          "source": "doc['cave.site.name.keyword'] + ' ' + doc['cave.site.alternativeName.keyword'] + ' ' + doc['cave.officialNumber']"
        }
      }
    },
    "highlight": {
      "fields":{
        "*": {
          "pre_tags": ["<span style=\"background-color: rgba(255, 255, 0, 0.665) !important;\">"],
          "post_tags": ["</span>"]
        }

      },
      "order": "score"
    },
    "query": {
      "bool": {
        "must" : [
        ]
      }
    },
  }
  // unfortunataly, elasticsearch does not provide a method, to exclude vertain fields from search. One can only give information on fields, where to search. We thus need to build our query by filtering excluded fields out of all fields:
  const excludedSearchfields = ["cave.caveAreaList", "relatedBibliographyList.keywordList", "relatedBibliographyList.annotationHTML", "lastChangedByUser", "relatedAnnotationList.w3c", "oe.relatedAnnotationList.w3c", "wallIDs", "wallDimensions", "dimension", "wallList", "geoJson", "w3c", "relatedImages", "creationTime", "images", 'annotoriousID', 'relatedAnnotationList.annotoriousID', 'oe.relatedAnnotationList.annotoriousID']

  var fields = getAllFields(['cave.fullname'], source, excludedSearchfields, "", pushed, pushedDouble, pushedTriple)
  console.log("fields", fields)
  const excludedNestedObjects = ["relatedBibliographyList.keywordList", "cave.caveAreaList", "cave.wallList", "wallIDs", "relatedImages", "images", "relatedAnnotationList.tags.children"]
  // A search also does not work in nested Queries. We have to include them manually.
  for (let searchedText of getWordSplit(params.searchtext)){
    var nestedQueries = buildNestedQueries(source, "", searchedText, excludedSearchfields, excludedNestedObjects)
    let shouldQuery = {
      "bool": {
        "should": [
        ]
      }
    }
    const rootSearch = {
      "query_string": {
        "fields": fields,
        "query" : searchedText

      }
    }
    rootSearch.query_string["analyzer"] = "autocomplete_search"
    shouldQuery.bool.should.push(rootSearch)
    for (var nestedQuery of nestedQueries){
      shouldQuery.bool.should.push(nestedQuery)
    }
    searchQuery.query.bool.must.push(shouldQuery)
  }
  // searchQuery["sort"] = [
  //   {
  //     "_script": {
  //       "type": "string",
  //       "script": {
  //         "lang": "painless",
  //         "source": "return doc['_id'].value.substring(0,1)"
  //       },
  //       "order": "desc"
  //     }
  //   },
  //   "_score"
  // ]
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'
  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: searchQuery
  })
}
export function getItemByIdLimited(params, from, size) {
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      'from': from,
      'size': size,
      'query': {
        'multi_match': {
          'query': params.id,
          'fields': params.type
        }
      }
    }
  })
}
export function getItemById(params) {
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      'size': 2000,
      'query': {
        'multi_match': {
          'query': params.id,
          'fields': params.type
        }
      }
    }
  })
}
export function getDepictionByAnnotation(params, from, size) {
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    auth: auth,
    data: {
      "size": size,
      "from": from,
      "query": {
        "bool": {
          "must": [
            {
              "bool" : {
                "should":
                    [
                      {
                        "nested": {
                          "path": "relatedAnnotationList",
                          "query": {
                            "nested": {
                              "path": "relatedAnnotationList.tags",
                              "query": {
                                "terms": {
                                  "relatedAnnotationList.tags.iconographyID": params.iconographyID
                                }
                              }
                            }
                          }
                        }
                      },
                      {
                        "nested": {
                          "path": "relatedIconographyList",
                          "query": {
                            "terms": {
                              "relatedIconographyList.iconographyID": params.iconographyID
                            }
                          }
                        }
                      },
                    ]
              }
            },
            {
              "exists": {
                "field": "depictionID"
              }
            }
          ]
        }
      }
    }
  })
}
export function getVersionsOfEntry(entry){
  var field
  var ID
  if (entry.depictionID){
    field = "content.depictionID"
    ID = entry.depictionID
  } else if (entry.iconographyID){
    field = "content.iconographyID"
    ID = entry.iconographyID
  } else if (entry.annotatedBibliographyID){
    field = "content.annotatedBibliographyID"
    ID = entry.annotatedBibliographyID
  } else if (entry.caveID){
    field = "content.caveID"
    ID = entry.caveID
  }
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_backup/_search' : 'kucha_backup/_search'

  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    // headers: {'Accept-Encoding': 'gzip,deflate', 'Content-Length':4000},
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    auth: auth,
    data: {
      "_source": {
        "excludes": [
          "content"
        ]
      },
      "sort" : [
        "timestamp"
      ],
      "size": 4000,
      "query": {
        "multi_match": {
          "query": ID,
          "fields": field
        }
      }
    }
  })
}
const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_backup/_doc/' : 'kucha_backup/_doc/'

export function getVersionOfEntry(entryUniqueID){
  return axios({
    url: process.env.VUE_APP_ESAPI + index + entryUniqueID,
    method: 'get',
    auth: auth,
    data: {
    }
  })
}

export function getDepictionByBibliography(params, from, size) {
  const index = (window.location.origin.includes("test") || window.location.origin.includes("localhost") || origin.includes("172.26") || origin.includes("192.168"))  ? 'kucha_deep/_search' : 'kucha_deep/_search'
  return axios({
    url: process.env.VUE_APP_ESAPI + index,
    method: 'post',
    auth: auth,
    data: {
      "size": size,
      "from": from,
      "query": {
        "nested": {
          "path": "relatedBibliographyList",
          "query": {
            "terms": {
              "relatedBibliographyList.annotatedBibliographyID": params.annotatedBibliographyID
            }
          }
        }
      }
    }
  })
}